import React, { useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import { reduxForm } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import _ from 'lodash';
import { isRequestInprogress } from '../firmsSelectors';
import { fetchEditFirm, updateEditFirm, clearEditFirmData } from '../firmsActions';
import ManageFirm from './ManageFirm';
import { validate } from './ValidateCreateFirm';

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: '100vh',
  },
  button: {
    float: 'right',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  updateButton: {
    marginLeft: theme.spacing(1),
  },
  titleText: {
    ...theme.typography.h5,
  },
  loadingSpinner: {
    position: 'relative',
    left: '44%',
  },
}));

export const EditFirm = ({
  history,
  match,
  reset,
  invalid,
  updateFirmRecord,
  loadFirmForEdit,
  clearForm,
  isLoading,
  hasInitialValues,
}) => {
  const classes = useStyles();
  /* URL param is camelCase (:externalCompanyId); API payload uses snake_case. */
  const externalCompanyId = _.get(match, 'params.externalCompanyId');

  useEffect(() => {
    loadFirmForEdit({
      external_company_id: externalCompanyId,
    });

    return () => {
      clearForm();
    };
  }, [externalCompanyId, loadFirmForEdit, clearForm]);

  const onCancel = () => {
    reset();
    history.replace('/firms');
  };

  return (
    <Grid
      container
      spacing={6}
      direction="column"
      alignItems="center"
      justify="center"
      className={classes.container}
    >
      <Grid
        container
        spacing={4}
        item
        xs={8}
      >
        <Grid item xs={12}>
          <IconButton className={classes.button} onClick={onCancel}>
            <Close />
          </IconButton>
          <Typography variant="h5" className={classes.titleText}>Edit Firm</Typography>
          {isLoading && <CircularProgress className={classes.loadingSpinner} />}
        </Grid>
        <ManageFirm />
        <Grid xs={12} item className={classes.buttonContainer}>
          <Button
            variant="outlined"
            onClick={onCancel}
          >
            CANCEL
          </Button>
          <Button
            color="primary"
            variant="contained"
            className={classes.updateButton}
            disabled={invalid || isLoading || !hasInitialValues}
            onClick={() => updateFirmRecord(history, {
              external_company_id: externalCompanyId,
            })}
          >
            SAVE
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

EditFirm.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      externalCompanyId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  reset: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  updateFirmRecord: PropTypes.func.isRequired,
  loadFirmForEdit: PropTypes.func.isRequired,
  clearForm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasInitialValues: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isLoading: isRequestInprogress(state),
  hasInitialValues: !_.isEmpty(_.get(state, 'firms.editFirmData', {})),
  initialValues: _.get(state, 'firms.editFirmData', null),
});

const mapDispatchToProps = {
  loadFirmForEdit: fetchEditFirm,
  updateFirmRecord: updateEditFirm,
  clearForm: clearEditFirmData,
};

let EditFirmForm = reduxForm({
  form: 'editFirm',
  validate,
  destroyOnUnmount: true,
  enableReinitialize: true,
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
})(EditFirm);

export default connect(mapStateToProps, mapDispatchToProps)(EditFirmForm);